export enum GrammaticalClass {
    Adjective = 'Adjektiv',
    Verb = 'Verb',
    Subject = 'Substantiv',
    Adverb = 'Adverb',
    Preposition = 'Preposisjoner',
    Expression = 'Uttrykk',
    Word = 'Ord',
    Pronoun = 'Pronomen',
    Conjunction = 'Konjunksjon',
    Interrogative = 'Spørreord',
    Determiner = 'Determinativ',
    Subjunction = 'Subjunksjon',
    French = 'Fransk',
    Norwegian = 'Norsk',
}
